import { HYDRATE_STATE } from "commons/src/reducers/indexActions";

import {
    SET_ACCOUNTS,
    ADD_ACCOUNT_DETAILS,
    ADD_PORTFOLIO,
    ADD_JOINT_OWNER,
    ADD_WRAPPER_DETAILS
} from "./accountsActions";
import { ADD_ANALYSIS } from "./analysisActions";

export const accounts = (state = {}, action) => {
    switch (action.type) {
        case SET_ACCOUNTS:
            return { ...action.accounts };

        case ADD_ACCOUNT_DETAILS:
            return {
                ...state,
                [action.accountNumber]: {
                    ...state[action.accountNumber],
                    details: action.details
                }
            };

        case ADD_PORTFOLIO:
            return {
                ...state,
                [action.accountNumber]: {
                    ...state[action.accountNumber],
                    portfolio: action.portfolio
                }
            };

        case ADD_JOINT_OWNER:
            return {
                ...state,
                [action.accountNumber]: {
                    ...state[action.accountNumber],
                    jointClients: action.ownerRelationships
                }
            };

        case ADD_WRAPPER_DETAILS:
            return {
                ...state,
                [action.accountNumber]: {
                    ...state[action.accountNumber],
                    wrapperDetails: action.wrapperDetails
                }
            };

        case ADD_ANALYSIS: {
            const allAccountsAnalysis =
                Object.values(action?.response?.HOLDINGS ?? {})?.[0]?.data ?? [];

            const newState = {
                ...state
            };

            allAccountsAnalysis.forEach(acc => {
                const accToUpdate = newState?.[acc.name];
                if (accToUpdate && accToUpdate.wrapperType !== acc.alias) {
                    newState[acc.name] = {
                        ...newState[acc.name],
                        alias: acc.alias
                    };
                }
            });

            return newState;
        }

        case HYDRATE_STATE:
            return {
                ...state,
                ...action.newState.accounts
            };

        default:
            return state;
    }
};
